document.addEventListener('alpine:init', () => {
  Alpine.data('Theme_Sizeguide', () => {
    return {
      selectedGuide: null,

      init() {
        Alpine.store('modals').register('sizeguide', 'rightDrawer');
        this.selectedGuide = 'cm'; // Valor padrão
      },

      selectGuide(option) {
        this.selectedGuide = option;
      },
    };
  });
});



